export const ATMLOCATION = {
    locationList: [
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Kandir par, Cumilla",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.46186",
            "lng": "91.18503"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "61, Dilkusha Commercial Area, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.725998",
            "lng": "90.417786"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Sima Blossom, House#3, Road#16(new), 27(old), Dhanmondi R/A, Dhaka-1209",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.744666",
            "lng": "90.372372"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Hotel Sea Palace Ltd. Kalatoli Road, Cox's Bazar",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "21.4205999",
            "lng": "91.9804744"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Plot CWS (C)-8, South Avenue, Gulshan-01, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "105, S S Kaiser Road, Feni Sadar, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.009312",
            "lng": "91.393988"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Jodiac Plaza, Saheb Bazar, Rajshahi",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.365721",
            "lng": "88.598533"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mishkat Arcade, 21/1, Agrabad C/A, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.326899",
            "lng": "91.8132"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Zaman Plaza , Beanibazar, Sylhet",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.821961",
            "lng": "92.158531"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "151/6 Green Road, Dhanmondi, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.750795",
            "lng": "90.387064"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "8/A Ramna Road, Ramna, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.733963",
            "lng": "90.401897"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Court Road, Moulvibazar",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.489955",
            "lng": "91.774976"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mizan Tower, 273, Bashurhat Road, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.936283",
            "lng": "91.301567"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Osman Plaza, 75, Elephant Road, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.737935",
            "lng": "90.387475"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "J R Super Market, Old Busstand, Main Road, Chakdev, Naogaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.808789",
            "lng": "88.942265"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Dinajpur Plaza, Ganeshtola, Dinajpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.630128",
            "lng": "88.635005"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "A Ali Complex, 45, R N Road, Jesore Purosavha, Jashore",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.165522",
            "lng": "89.213337"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Green Orlando, 42/4, Pragati Sarani, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.810009",
            "lng": "90.421667"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "S A Tower, Airport Road, South Halisahar, Bandar, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.292113",
            "lng": "91.780258"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Hazrat Shah Ali Girls School and College, Mazar Road, Mirpur-1, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.796916",
            "lng": "90.349843"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Rupsha Plaza, 73, KDA Avenue C/A, Sonadanga, Khulna",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.820364",
            "lng": "89.552961"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "140, Sadar Road, Barishal",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.699677",
            "lng": "90.369789"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "H R Plaza, 64 (Old), 90 (New), Bangabandhu Road, Narayongonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.616978",
            "lng": "90.501484"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "151-152, Ashrab Noor Mansion, Sadar Road, Natun Bazar, Patuakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.364502",
            "lng": "90.345338"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Balua Choumuhani, Dholia, Feni Sadar, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.232901",
            "lng": "91.391799"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Matuyail New Market Bhaban, Konapara, Demra, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.714898",
            "lng": "90.468385"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Chistia Tower, Kapor potti, Sonali Bank Road, Naogaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.8074599",
            "lng": "88.9447452"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Hotel Green Castle, Holding # 1, Patharghata, Reserve Bazar, Rangamati",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.6506927",
            "lng": "92.1955463"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mouja: Bairaichatal, Ward # 1, Begumganj, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.943559",
            "lng": "91.048066"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Honey Dew Point, Holding # 10, Abdul Malek Ukil Road, Maizdi, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.865375",
            "lng": "91.096595"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Momen Tower, 65, Choto Bazar, Mymensingh",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.757232",
            "lng": "90.410767"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Press Club Complex, Station Road, Rangpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.762644",
            "lng": "90.420053"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "2/1 Ring Road, Shamloli, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.773678",
            "lng": "90.361508"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Hatem Ali Complex, Singair Road, Hemayetpur, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.792561",
            "lng": "90.268488"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Noakhali Science & Technology University, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.792274",
            "lng": "91.101991"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Al-Hamra Shopping City, Zindabazar, Sylhet",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.889656",
            "lng": "91.872746"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Synthia Plaza, Main Road, Damudya Bazar, Damudya, Shariatpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.009",
            "lng": "24.009"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mohammad Hossain Complex, Moulvi Bazar Road, Chakbazar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.716431",
            "lng": "90.394872"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Rangpur Karupanno Limited, Station Road, Rangpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.748043",
            "lng": "89.254567"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Afsar Uddin Chowdhury Plaza, Asrompara, College Road, Thakurgaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "26.032271",
            "lng": "88.461531"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Debiganj Bazar, Holding#1892, Debiganj, Panchagarh",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "26.124679",
            "lng": "88.75421"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Bari Plaza, Bara Masjid Road, Nilphamari",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.936851",
            "lng": "88.850487"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Motiur Rahman Plaza, Konabari, Gazipur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.011104",
            "lng": "90.320703"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Holding no 212 SS Nazrul Islam Sarani, Bijoynagar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.731705",
            "lng": "90.410073"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Swadesh Tower, 41/6, Puranapaltan, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7325038",
            "lng": "90.4128565"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shisha Khorpa Bazar, Mouza: Khorpa, Porsa, Naogaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.023941",
            "lng": "88.611485"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Aziz Plaza, Mouza - Char Chartola, Ashugonj, Brahmmanbaria",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.035347",
            "lng": "91.002738"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Holding no 599, Ramjoymohajan Lane, Khatungonj, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.365128",
            "lng": "91.821739"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "74/1 Lalmohan Shaha Street, Dholaikhal, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.711684",
            "lng": "90.416194"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Aganagar, Chhotomasjid Road, South Keranigonj, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.704071",
            "lng": "90.402463"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "1284/1, Club Road, Patiya, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.294644",
            "lng": "91.980925"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Barogola, Bogura Sadar, Bogura",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.853707",
            "lng": "89.372565"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Holding no 2/4/A-2/6, Nawab Street, Wari, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Islamia Super Market, Holding no 1390, Old College Road, Maijdee Bazar, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.8833237",
            "lng": "91.0968797"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Zaman Complex, Holding-52-01, Ward-06, Sunamgonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.069176",
            "lng": "91.396288"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Diamond Jewelers, Holding No-44 N S Road, Kushtia",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.904976",
            "lng": "89.138269"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Malek Mansion, 128 Motijheel C/A, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.758798",
            "lng": "90.381904"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Khan Tower, Bhojeshwar Bazar, Naria, Shariatpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.260998",
            "lng": "90.386525"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Kachari Bazar, Rangpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Malik Tower, Holding No 43, 107, Boro Bazar Shahid Abul Kashem Sarak, Chuadanga",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.644136",
            "lng": "88.848133"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "31 no Nawab Yousuf Road, Khudro Babshai Shomiti, Nayabazar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.713801",
            "lng": "90.405564"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "11/1, Block#D, Kaderabad Housing, Katasur, Mohammadpur, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7536854",
            "lng": "90.3599132"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "43/3/2 Zigatola, Dhanmondi, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7395513",
            "lng": "90.3706301"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "234/6 Kochukhet (Main Road), Dhaka Cantonment, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.795053",
            "lng": "90.3874645"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shop No-2, 241/1 North Tejkunipara, Bijoy Sarani Link Road, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7644689",
            "lng": "90.3922287"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Karnaphuly Complex (Ground Floor), Holding#3373, Bhola Sadar, Bhola",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.544745",
            "lng": "90.585906"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "MM Shopping Complex, Holding No 573, Gourongo Bazar, Kishoregonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.434804",
            "lng": "90.782983"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Prantik 16, Subid Bazar, Sylhet",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.906696",
            "lng": "91.861666"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shop#64, Kalitala, Jhilim Road, Baro Indira Moor, Chapainawabgonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.596681",
            "lng": "88.270552"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Diganta Prosary Sangha (Ground Floor), Rajshahi Court, Rajpara, Rajshahi",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.373929",
            "lng": "88.5634506"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Saima Abdullah Plaza, Chandra Road, Faridgonj Bazar, Chandpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.136571",
            "lng": "90.745557"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Kamal Chamber, 61 Jubilee Road, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.340619",
            "lng": "91.827743"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "23 Atish Dipankar Road, Sabujbag, Bashaboo, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7412866",
            "lng": "90.435701"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "1/Ga, Central Bashaboo, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "House-367/A, Road-5 Tilpa Para (Ground Floor), Khilgaon, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7451257",
            "lng": "90.4271447"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "House-39, Road-10, Block-H, Section-2, Mirpur Housing, Mirpur, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.8101895",
            "lng": "90.3650839"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "House-185, Laxmipur Greater Road, Rajshahi",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Green Delta Aims Tower, 51-52, Mohakhali, C/A, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.800549",
            "lng": "90.324924"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Nur Market, Harirampur, Nozipur, Patnitola, Naogaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.041497",
            "lng": "88.760511"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Girls Plaza, Balahore, Niamatpur, Naogaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.830869",
            "lng": "88.575918"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "New Market, Zero Point, Sapahar, Naogaon",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.124225",
            "lng": "88.592496"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shajer Maya, Plot-62, Road-2, Mohammadi Housing Ltd, Mohammadpur, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shop No 39, Dhaka University Market, Katabon, Ramna, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7354289",
            "lng": "90.3886497"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Bhuiyan Complex, Zamgora Bazar, Ashulia, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.936941",
            "lng": "90.290304"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "House-19, Lake Drive Road, Sector-7, Uttara, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.8686838",
            "lng": "90.3931005"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Samad Mansion, Shahjalal Uposhohor, Sylhet",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.8860324",
            "lng": "91.8814613"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Latif Mansion, Madina Market, Sylhet",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.9104265",
            "lng": "91.8478159"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Uttara Ladies Club House-08, Road-08, Sector-01, Uttara, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.8576064",
            "lng": "90.4006535"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "S M Shopping Center, Pather Hat, Noapara, Raojan, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.440984",
            "lng": "91.910281"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Anowara Super Market, Adjacent to Biswa Road, Gobindagonj, Gaibandha",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.132006",
            "lng": "89.388251"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Dakpara, Keranigonj, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Aman Spinning Mills, Zirabo, Ashulia, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.9063735",
            "lng": "90.3184817"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Hazi A Aziz Super Market, Bhulta, Narayangonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.782661",
            "lng": "90.563827"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Holding No-1414/2/A, Plot No- 934/6-7, Block-A, Khilgaon, Dhaka-1219",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shipa Super Market, Sakhipur, Tangail.",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shezan Point (Ground Floor), 2, Indira Road, Farmgate, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7583071",
            "lng": "90.3892251"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "ARA MANSION 77 & 78 Airport Road, Amtoli, Mohakhali C/A, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.784795",
            "lng": "90.398522"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Razia Mansion, 184 Senpara Parbata, Mirpur-10, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.800553",
            "lng": "90.351191"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Nilphamari Uttara EPZ, Nilphamari",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.8594393",
            "lng": "88.866183"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Haji Edu Market, Atibazar, Keranigonj, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.730456",
            "lng": "90.333897"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Khadiza Mansion, Jelkahan Moor, Chinispur, Velanagar, Narsingdi",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.933753",
            "lng": "90.707585"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mosharaf Complex, Moddobazar, Amishapara, Sonaimuri, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.004468",
            "lng": "91.039817"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "30 Al Marjan, Kumar Patti, Jhalakhati",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.772183",
            "lng": "89.913492"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Monsur Super Market, Boardbazar Bustand, Gazipur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.945108",
            "lng": "90.382664"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mamun Super Market, Rajapur, Somaspur, Dhagonbhuyan, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.937732",
            "lng": "91.310591"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Techno Hannan Complex, H#285, Haji Mohsin Road, Chandpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.226311",
            "lng": "90.659873"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shimon Plaza, 10 Kalaiya, Bauphal, Patuakhali.",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.395631",
            "lng": "90.581806"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Babul Shopping Complex, Bojra Bazar, Sonaimuri, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.001777",
            "lng": "91.096205"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Salam Heights, Jakir Hossain Road, South Khulshi, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.361542",
            "lng": "91.814241"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Padma Bleaching & Dyeing Ltd, Golakandail, Bhulta, Rupgonj, Narayongonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Nilphamari Uttara EPZ, Nilphamari",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Tajumuddin Plaza, Kalakandi,  Teguriya, South Keranigonj, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.661081",
            "lng": "90.355667"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Holding No.#661, Donia Road, Dholaipar, Donia, Jatrabari, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.702563",
            "lng": "90.437879"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "22, Gareeb-E-Newaz Avenue, Sector-13, Uttara, Dhaka.",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.871202",
            "lng": "90.390879"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Balaram Bhaban, 126, Thana Road, Laxmipur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.937038",
            "lng": "90.828008"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Patwary Market, Samir Munshir Hat, 6 No. Kabilpur, Senbag, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.955466",
            "lng": "91.210179"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Zahir Plaza, Baipail, North Gazirchat, Shanirvar Dhamsona, Ashulia, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.936189",
            "lng": "90.268303"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Noor Mansion, Puratan Road, Sadar Dakkhin, Suaganj Bazar, Cumilla.",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.376166",
            "lng": "91.240704"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Holding # 137 138/1, Monohar Potti, Puratan Bazar, Sadar, Madaripur.",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.178738",
            "lng": "90.201761"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Murad Apparels Limited, South Gouripur, Ashulia, Savar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.8843784",
            "lng": "90.3143034"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Bhuiyan Market, Jhitka Bazar, Post:Jhitka, Union: Gala, Harirampur, Manikgonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.772183",
            "lng": "89.913492"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shah Jilani Tower, Outpara, Tangail Road, Gazipur Chowrasta, Gazipur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.989702",
            "lng": "90.378366"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Eastern Yakub Plaza, Race Course, Cumilla",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.464813",
            "lng": "91.175051"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Feroza Saleha Center, Baraiyarhat, Mirsarai, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.895166",
            "lng": "91.534213"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Sindurpur Bazar, Dagonbhuiyan, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.033002",
            "lng": "91.3010001"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Haris Chowdhury Bazar, Char Jubilee, Char Jabbar, Subornachar, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.658933",
            "lng": "91.095737"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Adib Plaza, Narasingpur Bus Stand, Tongi EPZ Road, Ashulia, Savar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Hazi Super Market, Mitrasen Potti, Goshairhat, Shariatpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.098083",
            "lng": "90.449998"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "R.K Chowdhury Shopping Complex, Birkot, Kankirhat, Senbag, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.041243",
            "lng": "91.203922"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Raju Plaza, Gouripur, Ashulia, Savar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.888631",
            "lng": "90.318662"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mandari Bazar, Laxmipur Sadar, Laxmipur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.941291",
            "lng": "90.910351"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "S.M Mansion, Gorai, Mirzapur, Tangail",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.099368",
            "lng": "90.156418"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "S.M Tower, B-11/1, Siddirgonj, Shimrail, Narayongonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.862238",
            "lng": "90.399703"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shahan Shopping Complex, Puran Bazar, Lalmonirhat Sadar, Lalmonirhat",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "25.919171",
            "lng": "89.444754"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Humayun Heights, Holding#70,  Ward#31, Sadarghat, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.327866",
            "lng": "91.830651"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Dream by Icon, Holding#2/4, Block#A, Mohammadpur Housing,  Dhaka-1207",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.762224",
            "lng": "90.371791"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Adib Plaza, Narasingpur Bus Stand, Tongi EPZ Road, Ashulia, Savar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Rangpur Karupanno Limited, Station Road, Rangpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "BFDC Bhaban, Plot#23-24, Kawranbazar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.752899",
            "lng": "90.392406"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "A Rashid Market, Netrokona Sadar, Netrokona",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Malek Bhaban, Udoy Shadurhat, Ramanandi, Char Matua, Noakhali Sadar, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Impetus Center, Holding-242/B, Tejgaon Industrial Area, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7707502",
            "lng": "90.4036621"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Rokeya Super Market, Chitoshi Bazar, Shaharasti, Chandpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.1651088",
            "lng": "91.0025021"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Matrichaya Bhaban, Deopara, Chandragonj, Laxmipur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.9473971",
            "lng": "90.9869016"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Center Point, Aronkhola, Dorinaricha, Ishwardi Pabna Main Road, Ishwardi, Pabna",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Amin Tower, Holding#601/722, Agrabad Access Road, Halishahar, Chattogram",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.3295041",
            "lng": "91.8012193"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "City Centre, Holding#16, Ward#1, Dhaka-Aricha Mahasarak, Manikgonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "234/6 Kochukhet, Dhaka Cantonment, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7952382",
            "lng": "90.387347"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shajer Maya, Plot-62, Road-2, Mohammadi Housing Ltd, Mohammadpur, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "House-39, Road-10, Block-H, Section-2, Mirpur Housing Estate, Mirpur, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Mirpur Section 6/C, Avenue 5, Plot 4, Mirpur, Dhaka-1216",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Gulshan North Club Limited, House#4/A, Road#71, Gulshan-2, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7803795",
            "lng": "90.4143436"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Patwary Tower, Old Munshirhat, Fulgazi, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.1090791",
            "lng": "91.4315727"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Matam Tower, Holding#50, S S Road, Sadar, Sirajgonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.4595801",
            "lng": "89.7066388"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Sultan Market, Holding#31, Hoseyn Shaheed Suhrawardy Road, Jhenaidah",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.544625",
            "lng": "89.176256"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Fuad Centre, Holding#37, Hospital Road, Kabirhat, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.8356225",
            "lng": "91.2034831"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Barodi Plaza, Barodi, Sonargaon, Narayongonj",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Sajeda Complex, Kashimpur, Kolakopa, Nawabgonj, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.6597793",
            "lng": "90.1618094"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Sofura Arcade, Holding#1340/1341, College Road, Chhagolnaiya, Feni",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "",
            "lng": ""
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "M/S Nilmoy Filling Station, Chaytonya Bazar, Shibpur, Narsingdi",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.0212636",
            "lng": "90.8113065"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Sayed Ali Complex, Ground Floor, Joypara, Dohar, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.618357",
            "lng": "90.11886"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "190, Inner Circular Road, Arambagh, Motijheel, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.7320293",
            "lng": "90.4205198"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "High School Road, Bhedarganj Poursobha, Shariatpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.1951583",
            "lng": "90.4461526"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Italy Plaza, Shariatpur Sadar, Shariatpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.2177199",
            "lng": "90.3474269"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Khorshed Plaza, Holding#240, College Road, Ward#08, Rajbari",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.763658",
            "lng": "89.645738"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Morshed Alam Complex, Rail Gate, Chowmuhani, Noakhali",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.946356",
            "lng": "91.120557"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Shahjalal Shopping Complex, Satbaria, Gohot North, Kachua, Chandpur",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.3047448",
            "lng": "90.9493963"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Aman Spinning Mills, Zirabo, Ashulia, Dhaka",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "23.9066899",
            "lng": "90.3197334"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Bhutu Babu Super Market, Kalasar, Goalabazar, Osmaninagar, Sylhet",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "24.7065721",
            "lng": "91.7337818"
        },
        {
            "branchNameInEnglish": "",
            "branchNameInBangla": "",
            "branchBusinessAddressInEnglish": "Haji Market, Shahid Kajol Sharani, Satkhira Municipality, Satkhira",
            "branchBusinessAddressInBangla": "",
            "areaPostCode": "",
            "swiftCode": "",
            "routingNo": "",
            "emailAddress": "",
            "telePhoneNumber": "",
            "nearestFamousPlace": "",
            "lat": "22.713162",
            "lng": "89.0706579"
        }
    ]
}